export default __webpack_public_path__ + "static/media/26-1.c9ab9bc0.mp3";